import { useField } from "formik";

import "../Forms.scss";

/**
 * DateInput component
 * @param {{
 *   name: string,
 *   label?: string,
 *   disabled?: boolean,
 *   bottomText?: string,
 *   className?: string,
 *   onChange?: (value: string) => void,
 *   min?: string | number,
 *   max?: string | number,
 *   autoFocus?: boolean
 * }} props
 * @returns {JSX.Element} DateInput
 */
function DateInput({ name, label, disabled, bottomText, className, onChange, min, max, autoFocus }) {
  const [field, meta] = useField(name);

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  }

  return (
    <div className={`input ${className} ${meta.touched && meta.error ? "error" : ""}`}>
      {label ? <label htmlFor={name}>{label}</label> : null}

      <div className="input-field">
        <input
          {...field}
          value={field.value || ""}
          type="date"
          name={name}
          id={name}
          disabled={disabled}
          onChange={handleChange}
          autoFocus={autoFocus}
          min={min}
          max={max}
        />
      </div>

      <div className="meta">
        {meta.touched && meta.error ? <small className="error-msg">{meta.error}</small> : null}
        {bottomText ? <small>{bottomText}</small> : null}
      </div>
    </div>
  );
}

export default DateInput;